export enum ConditionalState{
    Is = "is",
    IsNot = "is_not",
    IsEqualTo = "is_equal_to",
    IsNotEqualTo = "is_not_equal_to",
    Contains = "contains",
    DoesNotContain = "does_not_contain",
    StartsWith = "starts_with",
    DoesNotStartWith = "does_not_start_with",
    EndsWith = "ends_with",
    DoesNotEndWith = "does_not_end_with",
    IsEmpty = "is_empty",
    IsFilled = "is_filled",
    IsGreaterThan = "is_greater_than",
    IsLessThan = "is_less_than",
    IsEqualToDate = "is_equal_to_date",
    IsNotEqualToDate = "is_not_equal_to_date",
    DayOfWeekIs = "day_of_week_is",
    DayOfMonthIs = "day_of_month_is",
    MonthIs = "month_is",
    YearIs = "year_is",
    IsEqualToTime = "is_equal_to_time",
    IsNotEqualToTime = "is_not_equal_to_time",
    IsAfter = "is_after",
    IsBefore = "is_before",
    IsSelectedCountEqual = "is_selected_count_equal"
}
